import { render } from "./NotificationsView.vue?vue&type=template&id=bb1fbc02&ts=true"
import script from "./NotificationsView.vue?vue&type=script&lang=ts"
export * from "./NotificationsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__